import React from "react";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import {useTranslation} from "react-i18next";

export const SlideFull = props => {
    const {t} = useTranslation();
    const {background, title, textLeft, textRight, callback, type_id} = props;

    return (
        <div className="position-relative">
            <div
                className="bg_image_cover topBanner_slide"
                style={{
                    backgroundImage: background ? `url(${background})` : null,
                }}
            >
                <div className="overlay-gradient-topBanner" />
                <div className="container">
                    <div className="topBanner_content">
                        <h2 className="topBanner_video_title">{title}</h2>
                        <div className="topBanner_video_subTitle text-muted">
                            <span>{textLeft}</span>
                            <span className="separator">·</span>
                            <span>{textRight}</span>
                        </div>
                        <button
                            className="btn btn-light btn-lg w-fit-content text-uppercase rounded d-flex align-items-center"
                            onClick={callback}
                        >
                            {type_id === 1 ? (
                                <PlayArrowIcon className="mr-2" />
                            ) : (
                                <DescriptionOutlinedIcon className="mr-2" />
                            )}
                            {t("HOME.TOPBANNER.PLAY")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SlideFull;
